<template>
  <ConfigurationTypeTemplate
    :endPointData="endPointData"
    :textData="textData"
  />
</template>
<script setup>
import { computed } from 'vue';

// Utils
import { useRoute } from 'vue-router';
import generateTextData from '@/functions/generate_text_data';

// Components
import ConfigurationTypeTemplate from '@/components/generic/configuration_type_template.vue';

const route = useRoute();

const endPointData = computed(() => {
  const data = {
    equipmentTypeConfiguration: {
      newFormRoute: 'newEquipmentTypeForm',
      operationType: 'type',
      endpointIdentifier: 'equipment_types',
      typeGroupsEndpoint: `/organisations/${route.params.organisationId}/equipment_types`,
      nav: 'configuration.type.nav.equipment',
    },
    operationTypeConfiguration: {
      newFormRoute: 'newOperationTypeForm',
      operationType: 'type',
      endpointIdentifier: 'plant_types',
      typeGroupsEndpoint: `/organisations/${route.params.organisationId}/plant_types`,
      nav: 'configuration.type.nav.plant',
    }
  };
  return data[route.name];
});

const mainKey = 'configuration.type';
const textDataArray = [
  'search',
  'new',
];

const textData = computed(() => {
  return generateTextData(mainKey, textDataArray);
});
</script>
